import React, {useRef} from "react";
import {Button, Card, Tabs} from "antd";
import OrderForm from "./OrderForm";
import OrderDetailList from "./OrderDetailList";
import {ProfileTwoTone} from "@ant-design/icons";
import {useModelDispatchers} from "../../../models";
import {CM_ACTION_TYPE} from "../../../utils/constants";


export default function () {
    const {closeNav} = useModelDispatchers("nav");


    const formRef = useRef();
    const onSave = () => {
        formRef.current.insert();
    }
    const onReset = () => {
        formRef.current.reset();
    }
    const onClose = () => {
        closeNav();
    }

    const Title = () => {
        return (
            <div style={{display: "flex"}}>
                <h3 style={{flex: "1"}}>
                    <ProfileTwoTone/>
                    <span className="margin-left-8">新增销售订单</span>
                </h3>
                <div style={{width: "600px", textAlign: "right"}}>
                    <Button>打印</Button>
                    <Button className="margin-left-8">作废</Button>
                    <Button className="margin-left-8">退货</Button>
                    <Button className="margin-left-8">结算</Button>
                    <Button className="margin-left-8">库房确认</Button>
                    <Button className="margin-left-8" type="primary" onClick={onSave}>保存</Button>
                    <Button className="margin-left-8" onClick={onReset}>重置</Button>
                    <Button className="margin-left-8" onClick={onClose}>关闭</Button>
                </div>
            </div>
        )
    }
    return (
        <Card
            title={<Title/>}
            bordered={true}
            className="margin-top-8"
        >
            <Tabs tabPosition="top">
                <Tabs.TabPane tab="基本信息" key="1">
                    <OrderForm formRef={formRef} actionType={CM_ACTION_TYPE.INSERT}/>
                </Tabs.TabPane>
                <Tabs.TabPane tab="商品明细" key="2">
                    <OrderDetailList/>
                </Tabs.TabPane>

            </Tabs>

        </Card>
    );
}